export default function dimSettings(settings) {
  const displayUnit = settings.display_unit;
  const dimFormat =
    displayUnit === "millimeters" ? "DECIMAL" : settings.dimension_format;
  const sddp = settings.decimal_precision;
  const sdfp = settings.fractional_precision;
  const dimPrecision =
    displayUnit === "millimeters"
      ? settings.mm_precision
      : dimFormat === "DECIMAL"
        ? sddp
        : sdfp;

  return { displayUnit, dimFormat, dimPrecision };
}
